import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


const GenericAlert = (props) => {
    return (
        <Snackbar
            open={Boolean(props.message)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            autoHideDuration={4000}
            onClose={() => props.setMessage(undefined)}
        >
            <Alert
                onClose={() => props.setMessage(undefined)}
                severity={props.severity || "warning"}
                sx={{ width: '100%' }}
            >
                {props.message}
            </Alert>

        </Snackbar>
    );
};

export default GenericAlert;